'use client'

import React from 'react'

type UseCarouselOptions = {
    totalSlides: number
    slidesToShow: number
}

export function useCarousel({ totalSlides, slidesToShow }: UseCarouselOptions) {
    const [currentIndex, setCurrentIndex] = React.useState(0)

    const maxIndex = Math.max(0, totalSlides - slidesToShow)
    const canGoPrevious = currentIndex > 0
    const canGoNext = currentIndex < maxIndex

    const goToNext = React.useCallback(() => {
        setCurrentIndex((prev) => Math.min(prev + 1, maxIndex))
    }, [maxIndex])

    const goToPrevious = React.useCallback(() => {
        setCurrentIndex((prev) => Math.max(prev - 1, 0))
    }, [])

    const getTransformStyle = React.useCallback((): React.CSSProperties => {
        const slideWidth = 100 / slidesToShow
        const translateX = -(currentIndex * slideWidth)

        return {
            transform: `translateX(${translateX}%)`,
            transition: 'transform 0.3s ease-in-out',
        }
    }, [currentIndex, slidesToShow])

    return {
        currentIndex,
        canGoPrevious,
        canGoNext,
        goToNext,
        goToPrevious,
        getTransformStyle,
    }
}
